import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/Reports.css';
import UniversalFormForReports from './UniversalFormForReports';
import Modal from '../Modal/Modal';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
import CustomContainer from '../CustomElements/CustomContainer';
import Preloader from '../CustomElements/Preloader';

import { useSignOut } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../redux/actions/user.action';
import { getContractReportFromServer } from '../../redux/actions/documentation.action';
import { remove } from '../../redux/actions/loader.action';
import { useRole } from '../../customHook/useRole';
import translations from '../../content/PagesContent/DocumentationPage/documentationPageTranslations.json';
import useTranslations from '../../customHook/useTranslations';

function Reports(props) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);

  const user = useSelector((state) => state.user);
  // Получаем данные о процессе
  const loader = useSelector((state) => state.loader);

  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
    // setReportForm(initialReportForm)
    dispatch(remove());
  };

  const isReports = useRole('reports');
  const isCustomer = useRole('customer');
  // Состояние для формы contractReport
  const initialReportForm = {
    roadId: '',
    departmentId: '',
    directorateId: '',
    startDate: '',
    endDate: '',
  };

  const [uippsSummaryReport, setUippsSummaryReport] = useState({
    ...initialReportForm,
    reportType: 'summary',
    urlPath: 'uipps',
  });
  const [uippsDetailedReport, setUippsDetaileReport] = useState({
    ...initialReportForm,
    reportType: 'detailed',
    urlPath: 'uipps',
  });
  const [contractReport, setContractReport] = useState({
    ...initialReportForm,
    reportType: 'service',
  });

  const navigate = useNavigate();
  const signOut = useSignOut();
  function logout() {
    dispatch(logoutUser({ logout: true }));
    signOut();
    navigate('/login');
  }

  //отслеживаем выполнение запроса
  useEffect(() => {
    // Если нет ошибок, открываем модальное окно отчета
    if (!loader?.isLoading && loader?.isSuccess) {
      setIsOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loader?.isLoading, loader?.isSuccess]);
  return (
    <div className="reports">
      {/* тайтл и кнопка выхода */}
      <div className="reports-header">
        <div className="reports-title">{t?.reportSection || 'ОТЧЕТНОСТЬ'}</div>
        <div className="d-flex flex-column align-items-center align-self-center user-info">
          <span className="header-for-object_text-user">{user?.fullName}</span>
          <span className="header-for-object_text-role w-100">{user?.role && user?.role.join(', ')}</span>
        </div>
        <button type="button" className="btn btn-dark header-for-object_btn-logout" href="#" onClick={logout}>
          {t?.exitButton || 'Выход'}
          <img className="header-for-object_icon" src="/image/exit.svg" alt=""></img>
        </button>
      </div>

      {/* формы */}
      <div className="reports-form">
        {/* отчет 1 */}
        {isReports && (
          <>
            <UniversalFormForReports
              title={t?.summaryUippsReport || 'Сводный отчет по использованию УИППС'}
              action={getContractReportFromServer}
              optionalFields={['departmentId']}
              reportForm={uippsSummaryReport}
              initialReportForm={initialReportForm}
              setReportForm={setUippsSummaryReport}
              t={t}
            />

            {/* отчет 2 */}
            <UniversalFormForReports
              title={t?.detailedUippsReport || 'Детализированный отчет по использованию УИППС'}
              action={getContractReportFromServer}
              optionalFields={['departmentId']}
              reportForm={uippsDetailedReport}
              initialReportForm={initialReportForm}
              setReportForm={setUippsDetaileReport}
              t={t}
            />
          </>
        )}
        {/* отчет 3 contractReport */}

        {isCustomer && (
          <UniversalFormForReports
            title={t?.sadrReport || 'Отчет по использованию САДР'}
            action={getContractReportFromServer}
            reportForm={contractReport}
            initialReportForm={initialReportForm}
            setReportForm={setContractReport}
            t={t}
          />
        )}
      </div>
      <Preloader isLoading={loader?.isLoading} />
      <Modal isOpen={isOpen} onClose={closeModal} width="700px" height="450px">
        <CustomContainer>
          <ConfirmationPage
            addNew={t?.backToReportForm || 'К форме отчета'}
            confirmText={t?.confirmationTitle || 'Отчет сформирован!'}
            onConfirm={closeModal} // Функция для закрытия модального окна или отмены действия
          />
        </CustomContainer>
      </Modal>
    </div>
  );
}

export default Reports;
